__turbopack_context__.v({
  "copyright": "Footer-module__33nLDa__copyright",
  "footer": "Footer-module__33nLDa__footer",
  "footerMenu": "Footer-module__33nLDa__footerMenu",
  "footerMenuItem": "Footer-module__33nLDa__footerMenuItem",
  "logo": "Footer-module__33nLDa__logo",
  "subHeader": "Footer-module__33nLDa__subHeader",
});
